import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './calculators-vaf-access-finance.component.scss';
import * as $ from 'jquery';
var Month;
(function (Month) {
    Month[Month["JANUARY"] = 0] = "JANUARY";
    Month[Month["FEBRUARY"] = 1] = "FEBRUARY";
    Month[Month["MARCH"] = 2] = "MARCH";
    Month[Month["APRIL"] = 3] = "APRIL";
    Month[Month["MAY"] = 4] = "MAY";
    Month[Month["JUNE"] = 5] = "JUNE";
    Month[Month["JULY"] = 6] = "JULY";
    Month[Month["AUGUST"] = 7] = "AUGUST";
    Month[Month["SEPTEMBER"] = 8] = "SEPTEMBER";
    Month[Month["OCTOBER"] = 9] = "OCTOBER";
    Month[Month["NOVEMBER"] = 10] = "NOVEMBER";
    Month[Month["DECEMBER"] = 11] = "DECEMBER";
})(Month || (Month = {}));
var VafAfAmortisationItem = /** @class */ (function () {
    function VafAfAmortisationItem() {
        this.period = 0;
        this.noOfDays = 0.00;
        this.financeAmount = 0.00;
        this.monthlyRepayment = 0.00;
        this.calcInterest = 0.00;
        this.capital = 0.00;
        this.totalCollectable = 0.00;
    }
    return VafAfAmortisationItem;
}());
var VafAfAdbAmortisationItem = /** @class */ (function () {
    function VafAfAdbAmortisationItem() {
        this.totalAdb = 0.00;
        this.adbVsCapital = 0.00;
        this.adbVsCapital75 = 0.00;
        this.totalCapBal = 0.00;
        this.vafRate = 0.00;
        this.adbAdjustedRate = 0.00;
        this.netRate = 0.00;
        this.adbumberOfDays = 0;
        this.adbInterest = 0.00;
        this.erCalculated = 0.00;
        this.newApproxPayment = 0.00;
    }
    return VafAfAdbAmortisationItem;
}());
var CalculatorsVafAccessFinance = /** @class */ (function (_super) {
    tslib_1.__extends(CalculatorsVafAccessFinance, _super);
    function CalculatorsVafAccessFinance(element) {
        var _this = _super.call(this, element) || this;
        _this.formValid = true;
        _this.monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        return _this;
    }
    CalculatorsVafAccessFinance.prototype.init = function () {
        this.calculatorForm = this.element.querySelector('form');
        this.calculatorSubmit = this.calculatorForm.querySelector('.js-wpbbsa-calculator-vaf-af-calculate');
        this.calculatorReset = this.calculatorForm.querySelector('.js-wpbbsa-calculator-vaf-af-reset');
        this.paymentFrequencySelection = Array.from(this.element.querySelectorAll("input[name=\"payment-frequency\"]"));
        this.paymentFrequency = "MONTHLY";
        // this.termInputs = Array.from(this.element.querySelectorAll('input[name="term"]'));
        this.vafAccessFinanceTableLabel = document.querySelector('label[name=vaf-access-finance-table]');
    };
    CalculatorsVafAccessFinance.prototype.bindEvents = function () {
        var _this = this;
        this.calculatorSubmit.addEventListener('click', function (event) {
            _this.inputs = Array.from(_this.calculatorForm.querySelectorAll('input, select'));
            _this.vafAccessFinanceTableLabel.innerHTML = 'No information to display.';
            var btnViewPayments = Array.from(_this.element.querySelectorAll('.js-wpbbsa-calculator-view-payments'));
            if (_this.inputs) {
                _this.formValid = _this.validationService.validateWpbbsaCalculatorAllFields(_this.inputs, _this.calculatorSubmit);
            }
            if (_this.formValid) {
                _this.requestCalculations(_this.calculatorForm);
                // Analytics - Trigger form Complete when the user calculates the results
                _this.analyticsService.dtmFormComplete('complete', '');
                if ($(window).width() > 768) {
                    $('html,body').animate({
                        scrollTop: $(_this.element).closest('.wpbbsa-calculators').offset().top - 80
                    }, 'slow');
                    btnViewPayments.forEach(function (element) {
                        element.classList.remove('button--white');
                        element.classList.remove('button--border-blue');
                        element.classList.add('gradient-orange');
                    });
                }
                else if ($(window).width() < 768) {
                    $('html,body').animate({
                        scrollTop: $('div.wpbbsa-calculator-item__box').offset().top - 80
                    }, 'slow');
                    setTimeout(function () {
                        btnViewPayments.forEach(function (element) {
                            element.classList.remove('button--white');
                            element.classList.remove('button--border-blue');
                            element.classList.add('gradient-orange');
                        });
                    }, 800);
                }
            }
            else {
                if ($(window).width() > 768) {
                    $('html,body').animate({
                        scrollTop: $(_this.element).closest('.wpbbsa-calculators').offset().top - 80
                    }, 'slow');
                }
                else if ($(window).width() < 768) {
                    $('html,body').animate({
                        scrollTop: $(_this.element).closest('.wpbbsa-calculators').offset().top - 80
                    }, 'slow');
                }
                btnViewPayments.forEach(function (element) {
                    element.classList.remove('gradient-orange');
                    element.classList.add('button--white');
                    element.classList.add('button--border-blue');
                });
            }
        });
        this.paymentFrequencySelection.map(function (item) { return item.addEventListener("click", function (event) {
            var evt = event.target;
            _this.paymentFrequency = evt.value;
            _this.resetValues();
            _this.updateLabelsAndTerm(_this.paymentFrequency);
        }); });
        this.calculatorReset.addEventListener('click', function (event) {
            var btnViewPayments = Array.from(document.querySelectorAll('.js-wpbbsa-calculator-view-payments'));
            btnViewPayments.forEach(function (element) {
                element.classList.remove('gradient-orange');
                element.classList.add('button--white');
                element.classList.add('button--border-blue');
            });
            var lblCalculationError = Array.from(document.querySelectorAll('label[name=vaf-af-calculate-calculateError]'));
            lblCalculationError.forEach(function (element) {
                element.innerHTML = '';
            });
            _this.resetValues();
            _this.updateLabelsAndTerm("");
        });
    };
    CalculatorsVafAccessFinance.prototype.updateLabelsAndTerm = function (paymentFrequency) {
        var repaymentLabels = this.element.querySelectorAll('div.wpbbsa-calculator-item__box-inner--top__monthly-repayment p');
        var adbRepaymentLabels = this.element.querySelectorAll('div.js-wpbbsa-calculator-vaf-af-new-approx-avg-monthly-repayment--div p');
        var adbSavingsLabels = this.element.querySelectorAll('div.js-wpbbsa-calculator-vaf-af-average-saving-per-month-term--div p');
        if (paymentFrequency === "ANNUAL") {
            [].slice.call(repaymentLabels).forEach(function (p) {
                p.innerHTML = "Annual Repayment";
            });
            [].slice.call(adbRepaymentLabels).forEach(function (p) {
                p.innerHTML = "New Approximate Average Annual Repayment";
            });
            [].slice.call(adbSavingsLabels).forEach(function (p) {
                p.innerHTML = "Average Saving Per Year Over the Term";
            });
        }
        else {
            [].slice.call(repaymentLabels).forEach(function (p) {
                p.innerHTML = "Monthly Repayment";
            });
            [].slice.call(adbRepaymentLabels).forEach(function (p) {
                p.innerHTML = "New Approximate Average Monthly Repayment";
            });
            [].slice.call(adbSavingsLabels).forEach(function (p) {
                p.innerHTML = "Average Saving Per Month Over the Term";
            });
        }
    };
    CalculatorsVafAccessFinance.prototype.requestCalculations = function (form) {
        var _this = this;
        // -- View Containers -- //
        var loader = this.element.querySelector(".form__loader--access-finance-fields-container");
        var fieldsContainer = this.element.querySelector(".page-fields-container-access-calculator");
        var ErrorView = this.element.querySelector('.access-finance-error');
        loader.classList.remove("hidden");
        // -- Amounts -- //
        var financeAmountElem = form.querySelector('input[name="finance-amount"]');
        var interestRateElem = form.querySelector('input[name="interest-rate"]');
        var balloonPercentageElem = form.querySelector('input[name="balloon-percentage"]');
        var termElem = form.querySelector('input[name="term"]');
        var adbElem = form.querySelector('input[name="avarage-daily-balance"]');
        var postData = {
            'amountToFinance': Number(financeAmountElem.value),
            'interestRate': Number(interestRateElem.value),
            'balloonPercent': Number(balloonPercentageElem.value),
            'term': Number(termElem.value),
            'averageDailyBalance': Number(adbElem.value),
            'paymentFrequency': this.paymentFrequency === 'MONTHLY' ? 1 : 12,
        };
        var _config = {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        var url = this.baseUrl + "/leadsutils/vafafcalc";
        this.formsService.postForm(url, postData, _config).then(function (response) {
            if (response.status && response.status === 200 && response.data) {
                _this.displayCalculations(response.data);
            }
            else {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
                fieldsContainer.classList.add('hidden');
                ErrorView.classList.remove('hidden');
            }
            loader.classList.add("hidden");
        }).catch(function (response) {
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            ErrorView.classList.remove('hidden');
            fieldsContainer.classList.add('hidden');
            loader.classList.add("hidden");
        });
    };
    CalculatorsVafAccessFinance.prototype.displayCalculations = function (calculationsData) {
        var display_calculation_error = this.element.querySelectorAll('label[name=vaf-af-calculate-calculateError]');
        var display_monthly_repayment = this.element.querySelectorAll('span.js-wpbbsa-calculator-vaf-af-monthly-repayment');
        var display_total_term_rapayment = this.element.querySelectorAll('span.js-wpbbsa-calculator-vaf-af-total-term-repayment');
        var display_total_term_rapayment_div = this.element.querySelectorAll('div.js-wpbbsa-calculator-vaf-af-total-term-repayment--div');
        var display_approximate_finance_charges_term = this.element.querySelectorAll('span.js-wpbbsa-calculator-vaf-af-approximate-finance-charges-term');
        var display_approximate_finance_charges_term_div = this.element.querySelectorAll('div.js-wpbbsa-calculator-vaf-af-approximate-finance-charges-term--div');
        var display_new_approx_avg_monthly_repayment = this.element.querySelectorAll('span.js-wpbbsa-calculator-vaf-af-new-approx-avg-monthly-repayment');
        var display_average_saving_per_month_term = this.element.querySelectorAll('span.js-wpbbsa-calculator-vaf-af-average-saving-per-month-term');
        var display_average_saving_per_month_term_div = this.element.querySelectorAll('div.js-wpbbsa-calculator-vaf-af-average-saving-per-month-term--div');
        var display_new_approx_interest_rate = this.element.querySelectorAll('span.js-wpbbsa-calculator-vaf-af-new-approx-int-rate');
        var display_new_approx_interest_rate_div = this.element.querySelectorAll('div.js-wpbbsa-calculator-vaf-af-new-approx-int-rate--div');
        var display_new_total_repayments_term = this.element.querySelectorAll('span.js-wpbbsa-calculator-vaf-af-new-total-repayments-term');
        var display_new_total_repayments_term_div = this.element.querySelectorAll('div.js-wpbbsa-calculator-vaf-af-new-total-repayments-term--div');
        var display_interest_earnings_reduction_term = this.element.querySelectorAll('span.js-wpbbsa-calculator-vaf-af-interest-earnings-reduction-term');
        var display_interest_earnings_reduction_term_div = this.element.querySelectorAll('div.js-wpbbsa-calculator-vaf-af-interest-earnings-reduction-term--div');
        // -- Calculation Error -- //
        if (!calculationsData.message.includes('OK')) {
            this.resetValues();
            [].slice.call(display_calculation_error).forEach(function (label) {
                label.innerHTML = calculationsData.message;
            });
            return;
        }
        // -- Display / Hide Divs -- //
        [].slice.call(display_total_term_rapayment_div).forEach(function (div) {
            console.log(div);
            div.classList.remove('wpbbsa-calculator-form__hidden');
        });
        [].slice.call(display_approximate_finance_charges_term_div).forEach(function (div) {
            div.classList.remove('wpbbsa-calculator-form__hidden');
        });
        [].slice.call(display_average_saving_per_month_term_div).forEach(function (div) {
            div.classList.remove('wpbbsa-calculator-form__hidden');
        });
        [].slice.call(display_new_approx_interest_rate_div).forEach(function (div) {
            div.classList.remove('wpbbsa-calculator-form__hidden');
        });
        [].slice.call(display_new_total_repayments_term_div).forEach(function (div) {
            div.classList.remove('wpbbsa-calculator-form__hidden');
        });
        [].slice.call(display_interest_earnings_reduction_term_div).forEach(function (div) {
            div.classList.remove('wpbbsa-calculator-form__hidden');
        });
        // -- Monthly Repayment -- //
        [].slice.call(display_monthly_repayment).forEach(function (div) {
            div.innerHTML = calculationsData.instalmentAmount.toLocaleString('en-ZA', {
                style: 'currency',
                currency: 'ZAR',
                minimumFractionDigits: 2
            });
        });
        // -- Total Term Repayment -- //
        [].slice.call(display_total_term_rapayment).forEach(function (div) {
            div.innerHTML = (calculationsData.totalInstalments).toLocaleString('en-ZA', {
                style: 'currency',
                currency: 'ZAR',
                minimumFractionDigits: 2
            });
        });
        // -- Approxiamte Finance Charges Over Term -- //
        [].slice.call(display_approximate_finance_charges_term).forEach(function (div) {
            div.innerHTML = (calculationsData.totalInterest).toLocaleString('en-ZA', {
                style: 'currency',
                currency: 'ZAR',
                minimumFractionDigits: 2
            });
        });
        // -- ADB -- //
        // -- New Approximate Average Monthly Repayment -- //
        [].slice.call(display_new_approx_avg_monthly_repayment).forEach(function (div) {
            div.innerHTML = (calculationsData.averageReducedInstalment).toLocaleString('en-ZA', {
                style: 'currency',
                currency: 'ZAR',
                minimumFractionDigits: 2
            });
        });
        // -- Average Saving Per Month Over the Term -- //
        [].slice.call(display_average_saving_per_month_term).forEach(function (div) {
            div.innerHTML = (calculationsData.averageInstalmentReduction).toLocaleString('en-ZA', {
                style: 'currency',
                currency: 'ZAR',
                minimumFractionDigits: 2
            });
        });
        // -- New Approximate Interst Rate -- //
        [].slice.call(display_new_approx_interest_rate).forEach(function (div) {
            div.innerHTML = (calculationsData.effectiveDiscountedRate);
        });
        // -- New Total Repayments Over the Term -- //
        [].slice.call(display_new_total_repayments_term).forEach(function (div) {
            div.innerHTML = (calculationsData.totalReducedInstalments).toLocaleString('en-ZA', {
                style: 'currency',
                currency: 'ZAR',
                minimumFractionDigits: 2
            });
        });
        // -- Interest Earnings Reduction Over the Term -- //
        [].slice.call(display_interest_earnings_reduction_term).forEach(function (div) {
            div.innerHTML = (calculationsData.totalCreditInterest).toLocaleString('en-ZA', {
                style: 'currency',
                currency: 'ZAR',
                minimumFractionDigits: 2
            });
        });
    };
    CalculatorsVafAccessFinance.prototype.getVafAccessFinanceTableValue = function (value) {
        if (isNaN) {
            return Number(value).toLocaleString('en-ZA', {
                style: 'currency',
                currency: 'ZAR',
                minimumFractionDigits: 2
            });
        }
        else {
            return value.toLocaleString('en-ZA', {
                style: 'currency',
                currency: 'ZAR',
                minimumFractionDigits: 2
            });
        }
    };
    CalculatorsVafAccessFinance.prototype.resetValues = function () {
        var display_calculation_error = this.element.querySelectorAll('label[name=vaf-af-calculate-calculateError]');
        var display_monthly_repayment = this.element.querySelectorAll('span.js-wpbbsa-calculator-vaf-af-monthly-repayment');
        var display_total_term_rapayment = this.element.querySelectorAll('span.js-wpbbsa-calculator-vaf-af-total-term-repayment');
        var display_total_term_rapayment_div = this.element.querySelectorAll('div.js-wpbbsa-calculator-vaf-af-total-term-repayment--div');
        var display_approximate_finance_charges_term = this.element.querySelectorAll('span.js-wpbbsa-calculator-vaf-af-approximate-finance-charges-term');
        var display_approximate_finance_charges_term_div = this.element.querySelectorAll('div.js-wpbbsa-calculator-vaf-af-approximate-finance-charges-term--div');
        var display_new_approx_avg_monthly_repayment = this.element.querySelectorAll('span.js-wpbbsa-calculator-vaf-af-new-approx-avg-monthly-repayment');
        var display_average_saving_per_month_term = this.element.querySelectorAll('span.js-wpbbsa-calculator-vaf-af-average-saving-per-month-term');
        var display_average_saving_per_month_term_div = this.element.querySelectorAll('div.js-wpbbsa-calculator-vaf-af-average-saving-per-month-term--div');
        var display_new_approx_interest_rate = this.element.querySelectorAll('span.js-wpbbsa-calculator-vaf-af-new-approx-int-rate');
        var display_new_approx_interest_rate_div = this.element.querySelectorAll('div.js-wpbbsa-calculator-vaf-af-new-approx-int-rate--div');
        var display_new_total_repayments_term = this.element.querySelectorAll('span.js-wpbbsa-calculator-vaf-af-new-total-repayments-term');
        var display_new_total_repayments_term_div = this.element.querySelectorAll('div.js-wpbbsa-calculator-vaf-af-new-total-repayments-term--div');
        var display_interest_earnings_reduction_term = this.element.querySelectorAll('span.js-wpbbsa-calculator-vaf-af-interest-earnings-reduction-term');
        var display_interest_earnings_reduction_term_div = this.element.querySelectorAll('div.js-wpbbsa-calculator-vaf-af-interest-earnings-reduction-term--div');
        // -- Display / Hide Divs -- //
        [].slice.call(display_total_term_rapayment_div).forEach(function (div) {
            div.classList.add('wpbbsa-calculator-form__hidden');
        });
        [].slice.call(display_approximate_finance_charges_term_div).forEach(function (div) {
            div.classList.add('wpbbsa-calculator-form__hidden');
        });
        [].slice.call(display_average_saving_per_month_term_div).forEach(function (div) {
            div.classList.add('wpbbsa-calculator-form__hidden');
        });
        [].slice.call(display_new_approx_interest_rate_div).forEach(function (div) {
            div.classList.add('wpbbsa-calculator-form__hidden');
        });
        [].slice.call(display_new_total_repayments_term_div).forEach(function (div) {
            div.classList.add('wpbbsa-calculator-form__hidden');
        });
        [].slice.call(display_interest_earnings_reduction_term_div).forEach(function (div) {
            div.classList.add('wpbbsa-calculator-form__hidden');
        });
        for (var i = 0; i < this.paymentFrequencySelection.length; i++) {
            if (this.paymentFrequencySelection[i].value === this.paymentFrequency) {
                this.paymentFrequencySelection[i].checked = true;
            }
        }
        // this.paymentFrequency = `MONTHLY`;
        this.vafAccessFinanceTableLabel.innerHTML = 'No information to display.';
        // -- Calculation Error -- //
        [].slice.call(display_calculation_error).forEach(function (label) {
            label.innerHTML = '';
        });
        // -- Monthly Repayment -- //
        [].slice.call(display_monthly_repayment).forEach(function (div) {
            div.innerHTML = '0';
        });
        // -- Total Term Repayment -- //
        [].slice.call(display_total_term_rapayment).forEach(function (div) {
            div.innerHTML = '0';
        });
        // -- Approxiamte Finance Charges Over Term -- //
        [].slice.call(display_approximate_finance_charges_term).forEach(function (div) {
            div.innerHTML = '0';
        });
        // -- ADB -- //
        // -- New Approximate Monthly Repayment -- //
        [].slice.call(display_new_approx_avg_monthly_repayment).forEach(function (div) {
            div.innerHTML = '0';
        });
        // -- Average Saving Per Month Over the Term -- //
        [].slice.call(display_average_saving_per_month_term).forEach(function (div) {
            div.innerHTML = '0';
        });
        // -- New Approximate Interst Rate -- //
        [].slice.call(display_new_approx_interest_rate).forEach(function (div) {
            div.innerHTML = '0';
        });
        // -- New Total Repayments Over the Term -- //
        [].slice.call(display_new_total_repayments_term).forEach(function (div) {
            div.innerHTML = '0';
        });
        // -- Interest Earnings Reduction Over the Term -- //
        [].slice.call(display_interest_earnings_reduction_term).forEach(function (div) {
            div.innerHTML = '0';
        });
    };
    return CalculatorsVafAccessFinance;
}(Base));
export { CalculatorsVafAccessFinance };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/calculators-vaf-access-finance/calculators-vaf-access-finance.component.ts
// module id = 806
// module chunks = 0